var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-all"},[_c('Header',{ref:"headerComponent",attrs:{"variant":_vm.$route.meta.headerVariant || 'default',"isHide":_vm.$route.meta.headerIsHide === true}}),_c('KeepAlive',{attrs:{"max":"5"}},[_c('router-view',{ref:"routerView"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }